import z from "zod";
import { MetaSchema } from "./shared";

export const LoanLtvHistoryItem = z.object({
  id: z.string().uuid(),
  userLoanId: z.string().uuid(),
  ltv: z.string(),
  percentageChangesFromPrevious: z.string().nullable(),
  startedAt: z.string().nullable(),
  endedAt: z.string().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

const LoansLtvHistoryResponse = z.object({
  data: z.array(LoanLtvHistoryItem),
  meta: MetaSchema.default,
});

export default LoansLtvHistoryResponse;
